<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <div class="md-layout-item md-size-100 md-small-size-100">
          <autocomplete-async
            :items="customers"
            placeholder="Buscar Cliente..."
            @changed="onChangeSearch"
            @selected="onSelectedCustomer"
          >
            <template slot="autocomplete-item" slot-scope="{ row }">
              <label>{{row.codigo}} - {{row.nombre_busqueda}}</label>
            </template>
          </autocomplete-async>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100"></div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field
            :class="[
          {'md-valid': !errors.has('razonSocial') && touched.razonSocial},
          {'md-form-group': true},
          {'md-error': errors.has('razonSocial')}]"
          >
            <md-icon>face</md-icon>
            <label>Nombre</label>
            <md-input
              v-model="razonSocial"
              data-vv-name="razonSocial"
              type="text"
              name="razonSocial"
              readonly
              v-validate="modelValidations.razonSocial"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('razonSocial')">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('razonSocial') && touched.razonSocial"
              >done</md-icon>
            </slide-y-down-transition>
          </md-field>
          <md-field
            :class="[
          {'md-valid': !errors.has('email') && touched.email},
          {'md-form-group': true},
          {'md-error': errors.has('email')}]"
          >
            <md-icon>email</md-icon>
            <label>Email</label>
            <md-input
              v-model="email"
              data-vv-name="email"
              type="text"
              name="email"
              required
              v-validate="modelValidations.email"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('email')">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!errors.has('email') && touched.email">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <md-field
            :class="[
          {'md-valid': !errors.has('contact') && touched.contact},
          {'md-form-group': true},
          {'md-error': errors.has('contact')}]"
          >
            <md-icon>record_voice_over</md-icon>
            <label>Contacto</label>
            <md-input
              v-model="contact"
              data-vv-name="contact"
              type="text"
              name="contact"
              required
              v-validate="modelValidations.contact"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('contact')">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!errors.has('contact') && touched.contact">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { AutocompleteAsync } from "@/components";
import { apiServer } from "@/globalVars.js";
import { reclamacionService } from "@/_services";

export default {
  components: {
    SlideYDownTransition,
    AutocompleteAsync
  },
  props: {
    issue: {
      type: Object
    }
  },
  data() {
    return {
      selectedCustomer: null,
      customers: [],
      razonSocial: "",
      contact: "",
      email: "",
      touched: {
        razonSocial: false,
        contact: false,
        email: false
      },
      modelValidations: {
        razonSocial: {
          required: true
        },
        contact: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },
  methods: {
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        res = res && this.issue.cliente._id != null;
        this.$emit("on-validated", res);
        return res;
      });
    },
    loadAlbaranes() {
      reclamacionService
        .getAlbaranUltimos(this.issue.cliente._id)
        .then(data => {
          this.issue.albaranes = data;
        });
    },
    onChangeSearch(value) {
      fetch(apiServer + "/cliente/search?text=" + value)
        .then(response => response.json())
        .then(data => {
          this.customers = data;
        });
    },
    onSelectedCustomer(value) {
      this.issue.cliente = value;
      this.razonSocial =
        this.issue.cliente.codigo +
        " - " +
        this.issue.cliente.razon_social +
        " - " +
        this.issue.cliente.nombre_busqueda;
      this.contact = this.issue.cliente.contacto.nombre;
      this.email = this.issue.cliente.contacto.email;
      this.loadAlbaranes();
    }
  },
  watch: {
    razonSocial() {
      this.touched.razonSocial = true;
    },
    contact() {
      this.touched.contact = true;
      this.issue.cliente.contacto.nombre = this.contact;
    },
    email() {
      this.touched.email = true;
      this.issue.cliente.contacto.email = this.email;
    }
  }
};
</script>
<style scoped>
.selector-cliente {
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
